import React from "react";
import { Link } from "react-router-dom";

interface IProps {
  titre?: string;
  description?: string;
  img_rond?: string;
  img_gauche: boolean;
  path?: string;
}

const CpntBlocPresentation: React.FC<IProps> = ({titre, description, img_rond, img_gauche,path }) => {
  return (
    <>
    <hr className={`col-12 col-md-2 mx-auto text-greydark`}/>
    {/* Affichage desktop (md et plus) */}
    <div className="d-none d-md-flex row align-items-center">
      <div className={`col-sm-12 text-md-end ${img_gauche ? "col-md-4" : "col-md-2 "}`}>
      {img_gauche && <img src={img_rond} alt="" className="img-fluid img-rond" />}
      </div>
      <div className={`col-md-6 offset-md-0 col-sm-10 offset-sm-1 mt-0 d-flex ${img_gauche ? "justify-content-md-start ps-3" : "justify-content-md-end pe-3"}`}>
      <div className="text-start">
        <div className="description-Titre"><b>{titre}</b></div>
          <div>{description}</div>
        </div>
      </div>
      <div className={`col-sm-12 text-md-start ${img_gauche ? "col-md-2" : "col-md-4"}`}>
      {!img_gauche && <img src={img_rond} alt="" className="img-fluid img-rond" />}
      </div>
    </div>


  {/* Affichage mobile (sm et en dessous) */}
  <div className="d-block d-md-none row align-items-center">
      <div className={`col-10 offset-1 mt-5 mt-md-0 `}>
      <div className="text-center">
        <div className="description-Titre"><b>{titre}</b></div>
          <div>{description}</div>
        </div>
      </div>
      <div className={`col-12 text-md-start`}>
      {<img src={img_rond} alt="" className="img-fluid img-rond" />}
      </div>
    </div>

       {/* Bouton "En savoir plus" centré sous le bloc */}
       {path && 
       <div className="text-center mt-1 mb-4">
        {/* <button className="btn btn-secondary">En savoir plus</button> */}
        <Link className="btn btn-secondary" to={path}>
          En savoir plus
        </Link>
      </div>
      }
      {/* </div> */}
      </>
  );
};

export default CpntBlocPresentation;


